<script>
import Rating from '../../Rating'

export default {
  name: 'ActiveOrderItem',
  components: { Rating },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    deliverOnFormatted() {
      const date = this.$moment(this.order.deliverOn)
      const hour = this.$moment().hour(date.hour() + 1)

      return `${date.format('ddd, D MMM, ha')}-${hour.format('ha')}`
    }
  }
}
</script>

<template>
  <v-card class="pa-1">
    <!-- Seller & delivery info -->
    <v-list-item class="pt-1 mb-2">
      <v-list-item-avatar color="grey lighten-3" size="56" class="mr-4 my-0">
        <v-img :src="order.seller.avatar" :lazy-src="order.seller.avatar" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="d-flex subtitle-2 font-weight-bold mb-1">
          <span class="flex-grow-1">
            {{ order.seller.firstName }}
          </span>
          <div class="d-inline-block">
            <Rating :rating="order.seller.sellerRating" />
          </div>
        </v-list-item-title>
        <v-list-item-subtitle class="caption red--text">
          Delivery {{ deliverOnFormatted }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- Items list -->
    <v-list dense>
      <v-list-item
        v-for="lineItem in order.lineItems"
        :key="lineItem.id"
        class="order-item"
      >
        <!-- Product photo -->
        <v-list-item-avatar
          class="mr-3 my-1 product-photo"
          color="grey lighten-3"
          size="32"
        >
          <v-img
            :src="lineItem.product.photo"
            :lazy-src="lineItem.product.photo"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          {{ lineItem.product.name }}
        </v-list-item-content>
        <div class="secondary--text">{{ lineItem.quantity }}×</div>
      </v-list-item>
    </v-list>

    <!-- Actions -->
    <v-card-actions class="actions py-3">
      <v-spacer />
      <v-btn
        outlined
        rounded
        color="primary"
        :to="{
          name: 'ReceiptView',
          params: { id: order.id, preloaded: { order } }
        }"
      >
        View receipt
      </v-btn>
      <v-btn
        outlined
        rounded
        color="secondary"
        :to="{ name: 'OrderIssueView', params: { id: order.id } }"
      >
        Report
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped lang="sass">
.v-card
  box-shadow: none
  border: 1px solid rgba(0, 0, 0, 0.09)

.order-item
  font-size: 14px

.product-photo
  border-radius: 4px

.actions .v-btn
  padding: 0 20px
  &:before
    background-color: white !important
</style>
